// ***********************************************************************
// Assembly         : Veriteq.Partner.Web
// Author           : Mike Palmer
// Created          : 06-21-2024
//
// Last Modified By : Mike Palmer
// Last Modified On : 06-21-2024
// ***********************************************************************
// <copyright file="_file.js" company="NSA Group Ltd">
//     Copyright (c) NSA Group Ltd. All rights reserved.
// </copyright>
// <summary>
//     JavaScript utilities for handling file downloads from base64 encoded content.
// </summary>
// ***********************************************************************

window.file = window.file || {};

/**
 * Downloads a file from a base64 encoded string.
 *
 * @function download
 * @memberof window.file
 * @param {string} fileName - The name of the file to be downloaded.
 * @param {string} fileContentType - The MIME type of the file (e.g., 'application/pdf').
 * @param {string} byteBase64 - The base64 encoded string representing the file content.
 */
window.file.download = function (fileName, fileContentType, byteBase64) {
    const byteCharacters = atob(byteBase64);
    const byteNumbers = new Array(byteCharacters.length);

    for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: fileContentType });
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = fileName;
    link.click();

    window.URL.revokeObjectURL(link.href);
};